(function () {
  'use strict';
  if (window.CPStaffCoffee) { window.CPStaffCoffee.initAll(document); return; }
  const LIMITS = Object.freeze({people:[1,100000,1],participation:[0,100,1],drinks:[0,50,.1],days:[0,31,1],price:[0,1000,.01],cost:[0,1000,.01],fixed:[0,1000000,.01],other:[0,1000000,.01],reserve:[0,1000000,.01],upfront:[0,10000000,.01],target:[0,10000000,.01],external:[0,1000,.01],percent:[0,100,.01],fee:[0,100,.01],vat:[0,100,.01]});
  const ROUTES = ['either','bean','soluble'], MILKS = ['mixed','fresh','powder','black'];
  const currency = new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP',minimumFractionDigits:2,maximumFractionDigits:2});
  const decimal = new Intl.NumberFormat('en-GB',{maximumFractionDigits:2});
  const cash = x => currency.format(Math.abs(x) < 0.0000001 ? 0 : x);
  const ceilPenny = x => Math.ceil((x-1e-9)*100)/100;
  function validate(input) {
    if (!input || typeof input !== 'object' || Array.isArray(input)) return null;
    const clean = {};
    for (const [key,rule] of Object.entries(LIMITS)) {
      const x = input[key];
      if (typeof x !== 'number' || !Number.isFinite(x) || x < rule[0] || x > rule[1] || Math.abs(x/rule[2]-Math.round(x/rule[2])) > 1e-5) return null;
      clean[key] = x;
    }
    if (!ROUTES.includes(input.route) || !MILKS.includes(input.milk)) return null;
    clean.route=input.route; clean.milk=input.milk;
    return clean;
  }
  function calculate(raw) {
    const a=validate(raw); if (!a) return null;
    const units=a.people*a.participation/100*a.drinks*a.days;
    const netUnit=a.price/(1+a.vat/100);
    const feeUnit=a.price>0?a.price*a.percent/100+a.fee:0;
    const unitMargin=netUnit-a.cost-feeUnit;
    const overhead=a.fixed+a.other;
    const revenue=units*a.price, vat=revenue-units*netUnit, ingredients=units*a.cost, fees=units*feeUnit;
    const operating=units*unitMargin-overhead;
    const balance=operating-a.reserve;
    const funded=Math.min(a.reserve,Math.max(0,operating));
    const denominator=1/(1+a.vat/100)-a.percent/100;
    let breakPrice=null;
    if (units>0) {
      if (a.cost+overhead+a.reserve===0) breakPrice=0;
      else if (denominator>0) breakPrice=ceilPenny((a.cost+a.fee+(overhead+a.reserve)/units)/denominator);
    }
    const breakDay=unitMargin>0&&a.days>0?Math.ceil((overhead+a.reserve)/(unitMargin*a.days)-1e-9):null;
    const payback=a.upfront>0&&balance>0?a.upfront/balance:null;
    const reserveTime=a.target>0&&funded>0?a.target/funded:null;
    return {input:a,units,revenue,vat,ingredients,fees,overhead,operating,balance,funded,breakPrice,breakDay,payback,reserveTime,annual:balance*12,reserveAnnual:funded*12,saving:Math.max(0,a.external-a.price),cautious:units*.75*unitMargin-overhead-a.reserve};
  }
  function getStrings(root) {
    try { const x=JSON.parse(root.querySelector('[data-staff-strings]').textContent); return x&&x.model&&x.messages?x:{model:{},messages:{}}; }
    catch (_) { return {model:{},messages:{}}; }
  }
  function formatOutputs(r,s) {
    const m=s.messages, months=x=>decimal.format(Math.ceil(x*10-1e-8)/10)+' '+(m.months||'months');
    return {balance:cash(Math.abs(r.balance)),monthly:decimal.format(r.units),revenue:cash(r.revenue),vat_out:cash(r.vat),ingredients:cash(r.ingredients),fees:cash(r.fees),fixed_total:cash(r.overhead),reserve_target:cash(r.input.reserve),break_price:r.breakPrice===null?(r.units>0?m.not_possible:m.no_usage):cash(r.breakPrice),break_day:r.breakDay===null?m.not_possible:decimal.format(r.breakDay),cautious:cash(r.cautious),payback:r.input.upfront===0?m.no_upfront:r.payback===null?m.no_payback:months(r.payback),reserve_funded:cash(r.funded),reserve_year:cash(r.reserveAnnual),reserve_time:r.input.target===0?m.no_target:r.reserveTime===null?m.no_fund:months(r.reserveTime),saving:cash(r.saving),annual_balance:cash(r.annual)};
  }
  function buildSummary(raw,s) {
    const r=calculate(raw); if (!r) return '';
    const lines=[s.messages.summary_title||'Staff coffee planning — illustrative figures',''];
    for (const key of Object.keys(LIMITS)) lines.push((s.model[key]||key)+': '+decimal.format(r.input[key]));
    lines.push((s.model.route||'Coffee route')+': '+(s.model[r.input.route]||r.input.route),(s.model.milk||'Milk route')+': '+(s.model[r.input.milk]||r.input.milk),'');
    const o=formatOutputs(r,s);o.balance=cash(r.balance);
    for (const [key,value] of Object.entries(o)) lines.push((key==='balance'?(s.model.remaining||key):(s.model[key]||key))+': '+value);
    lines.push('',s.messages.summary_caution||'',s.model.note||'');
    return lines.join('\n');
  }
  function readForm(root) {
    const a={};let valid=true;
    root.querySelectorAll('[data-staff-input]').forEach(e=>{
      const key=e.dataset.staffInput;
      if (key==='route'||key==='milk') {a[key]=e.value;return;}
      const ok=e.value.trim()!==''&&e.validity.valid;
      e.setAttribute('aria-invalid',ok?'false':'true');
      if (!ok) valid=false;
      a[key]=e.valueAsNumber;
    });
    return valid?validate(a):null;
  }
  function initModel(root) {
    if (root.dataset.staffReady==='1') return;root.dataset.staffReady='1';
    const s=getStrings(root),outputs=root.querySelectorAll('[data-staff-output]'),enquiry=root.querySelector('[data-staff-enquiry]'),copy=root.querySelector('[data-staff-copy]'),status=root.querySelector('[data-staff-status]'),results=root.querySelector('[data-staff-results]');
    let current=null;
    function update() {
      current=readForm(root); const r=current?calculate(current):null;
      const base=new URL(root.dataset.contactUrl||'/pages/contact-us',location.origin);
      if (base.origin!==location.origin) {base.href=location.origin+'/pages/contact-us';}
      base.search='';base.searchParams.set('intent','cashless');base.hash='contact-form';
      if (!r) {
        outputs.forEach(e=>e.textContent='—');status.textContent=s.messages.invalid||'Enter valid figures.';results.dataset.state='invalid';
        root.querySelector('[data-staff-result-note]').textContent='';
        enquiry.href=base.pathname+base.search+base.hash;enquiry.textContent=s.model.generic||'Ask about my setup';copy.disabled=true;
        const old=root.querySelector('[data-staff-copy-text]');old.value='';old.hidden=true;
        return;
      }
      const out=formatOutputs(r,s);outputs.forEach(e=>e.textContent=out[e.dataset.staffOutput]??'—');
      root.querySelector('[data-staff-balance-label]').textContent=r.balance<-.005?s.model.shortfall:s.model.remaining;
      results.dataset.state=r.balance<-.005?'shortfall':r.balance>.005?'surplus':'even';
      status.textContent=r.balance<-.005?s.messages.negative:r.balance>.005?s.messages.positive:s.messages.even;
      const notes=[r.balance<-.005?s.messages.negative_note:s.messages.positive_note];
      if (r.funded+.005<r.input.reserve) notes.push(s.messages.reserve_unfunded);
      if (r.input.fixed===0) notes.push(s.messages.zero_fixed);
      root.querySelector('[data-staff-result-note]').textContent=notes.filter(Boolean).join(' ');
      root.querySelectorAll('[data-staff-preset]').forEach(b=>b.setAttribute('aria-pressed',Number(b.dataset.staffPreset)===current.price?'true':'false'));
      base.searchParams.set('source','staff-coffee');
      enquiry.href=base.pathname+base.search+base.hash;enquiry.textContent=(s.model.enquiry||'Send these figures with my enquiry')+' →';copy.disabled=false;copy.hidden=false;
      const old=root.querySelector('[data-staff-copy-text]');if(!old.hidden)old.value=buildSummary(current,s);
    }
    root.addEventListener('cp:planning-inputs-restored',update);
    root.addEventListener('input',e=>{if(e.target.matches('[data-staff-input]'))update();});
    root.addEventListener('change',e=>{if(e.target.matches('[data-staff-input]'))update();});
    root.querySelectorAll('[data-staff-preset]').forEach(b=>b.addEventListener('click',()=>{
      const input=root.querySelector('[data-staff-input="price"]');input.value=b.dataset.staffPreset;input.dispatchEvent(new Event('input',{bubbles:true}));
    }));
    copy.addEventListener('click',async()=>{
      const value=current?buildSummary(current,s):'';if(!value)return;
      const note=root.querySelector('[data-staff-copy-status]'),area=root.querySelector('[data-staff-copy-text]');
      try { if (!navigator.clipboard||!navigator.clipboard.writeText) throw new Error('Clipboard not available');await navigator.clipboard.writeText(value);note.textContent=s.messages.copied; }
      catch (_) {area.value=value;area.hidden=false;area.focus();area.select();note.textContent=s.messages.copy_fallback;}
    });
    enquiry.addEventListener('click',event=>{if(!current||!window.CPEnquiry)return;event.preventDefault();window.CPEnquiry.present({id:'staff-coffee',source:'Staff coffee / cashless model',type:'cashless',context:'business',summary:buildSummary(current,s)},root,{focus:true});});
    root.addEventListener('change',event=>{if(current&&event.target.matches('[data-staff-input]')&&window.CPEnquiry)window.CPEnquiry.present({id:'staff-coffee',source:'Staff coffee / cashless model',type:'cashless',context:'business',summary:buildSummary(current,s)},root);});
    update();
  }
  function initBrief(root) {
    if(root.dataset.staffReady==='1')return;root.dataset.staffReady='1';
    const query=new URLSearchParams(location.search);
    if(query.get('intent')!=='cashless'||query.get('source')!=='staff-coffee'||!query.has('sc'))return;
    const s=getStrings(root),field=root.querySelector('[data-staff-brief-text]'),note=root.querySelector('[data-staff-brief-status]');
    let values=null;
    try {const raw=query.get('sc');if(raw.length<=2500)values=validate(JSON.parse(raw));}catch(_){}
    if(!values){root.hidden=false;root.querySelector('details').hidden=true;note.textContent=s.messages.contact_invalid;return;}
    field.value=buildSummary(values,s);root.hidden=false;field.disabled=false;note.textContent=s.messages.contact_added;
    const form=root.closest('form'),host=root.closest('[data-cp-contact-v14]'),select=form&&form.querySelector('[data-contact-intent]');
    let removed=false;
    function sync(){const active=!removed&&(!select||select.value==='Staff coffee / cashless');root.hidden=!active;field.disabled=!active;}
    if(select)select.addEventListener('change',sync);
    if(host)host.querySelectorAll('[data-contact-route-link]').forEach(a=>a.addEventListener('click',()=>{Promise.resolve().then(sync);}));
    root.querySelector('[data-staff-brief-remove]').addEventListener('click',()=>{removed=true;field.value='';sync();const clean=new URL(location.href);clean.searchParams.delete('sc');clean.searchParams.delete('source');history.replaceState(null,'',clean.pathname+clean.search+clean.hash);});
    sync();
  }
  function initAll(scope) {
    const modelNodes=[...(scope.querySelectorAll?scope.querySelectorAll('[data-cp-staff-model]'):[])];if(scope.matches&&scope.matches('[data-cp-staff-model]'))modelNodes.unshift(scope);modelNodes.forEach(initModel);
    const briefNodes=[...(scope.querySelectorAll?scope.querySelectorAll('[data-cp-staff-brief]'):[])];if(scope.matches&&scope.matches('[data-cp-staff-brief]'))briefNodes.unshift(scope);briefNodes.forEach(initBrief);
  }
  window.CPStaffCoffee=Object.freeze({calculate,validate,buildSummary,initAll});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initAll(document),{once:true});else initAll(document);
  document.addEventListener('shopify:section:load',e=>initAll(e.target));
})();
